import { createReducer } from '@reduxjs/toolkit';
import { GET_ORGANIZATIONS } from '../actions/organization';

type Paginated<T> = {
  rows: T[];
  count: number;
  pagination: unknown;
};
// TODO: infer type from docs
type Organization = unknown;

export type OrganizationState = {
  organizations: Paginated<Organization>;
};

const initState: OrganizationState = {
  organizations: { rows: [], count: 0, pagination: {} },
};

const organizationReducer = createReducer(initState, (builder) =>
  builder.addCase(GET_ORGANIZATIONS, (state, action) => {
    return { ...state, organizations: action.payload };
  })
);

export default organizationReducer;
